import { render } from "./EventViewSettings.vue?vue&type=template&id=4c9809d9&scoped=true&lang=pug"
import script from "./EventViewSettings.vue?vue&type=script&lang=js"
export * from "./EventViewSettings.vue?vue&type=script&lang=js"

import "./EventViewSettings.vue?vue&type=style&index=0&id=4c9809d9&scoped=true&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9809d9"]])

export default __exports__